module.exports = __webpack_public_path__ + "img/card_220220562.9f892158.png";